<div class="payment-form">
    <div class="section payment-options" *ngIf="!paymentOption">
        <span class="section-title">
            Método de pago
        </span>
        <span class="section-description">
            Por favor elija uno de los siguientes métodos de pago.
        </span>
        <button mat-raised-button color="primary" class="garantor-button" (click)="paymentOption = 'CREDITO'" *ngIf="getQuoteOptions('CREDITO').length">
            Tarjeta de crédito
        </button>
        <button mat-raised-button color="primary" class="garantor-button" (click)="paymentOption = 'DEBITO'" *ngIf="getQuoteOptions('DEBITO').length">
            Tarjeta de débito
        </button>
        <button mat-raised-button color="primary" class="garantor-button transferencia-button" (click)="paymentOption = 'TRANSFERENCIA'" *ngIf="getQuoteOptions('TRANSFERENCIA').length">
            Transferencia
        </button>
        <button mat-raised-button color="primary" class="garantor-button" (click)="paymentOption = 'EFECTIVO'" *ngIf="user?.tipo === 'CORPORATIVO'">
            Efectivo
        </button>
    </div>
    <div class="section payment-options" *ngIf="paymentOption">
        <span class="section-title">
            Método de pago
        </span>
        <span class="section-description">
            {{ getSectionTitle() }}
        </span>
        <button mat-raised-button color="accent" class="garantor-button mini change-payment-method" (click)="paymentOption = undefined; updatePayment({ opcion: undefined })">
            Cambiar método de pago
        </button>
    </div>
    <div class="section quote-options" *ngIf="paymentOption === 'CREDITO' || paymentOption === 'DEBITO'">
        <span class="section-title">
            Opciones de pago
        </span>
        <span class="section-description">
            Por favor elija una de las opciones de pago.
        </span>
        <app-data-table
            class="data-table"
            [rows]="getQuoteOptions(paymentOption)"
            [columns]="paymentOptionsTableColumns"
            selectionType="single"
            [selected]="[payment.opcion]"
            (selectedChange)="onPaymentOptionChange($event)"
        ></app-data-table>
    </div>
    <div class="section payment-config" *ngIf="paymentOption && (payment.opcion || paymentOption === 'EFECTIVO')">
        <span class="section-title">
            {{ getSectionTitle() }}
        </span>
        <span class="section-description">
            {{ getSectionDescription() }}
        </span>
        <span class="ammount" *ngIf="paymentOption !== 'EFECTIVO' && payment.opcion.cuotas === 1">
            Monto a pagar: {{ utilsService.parseByType(payment.opcion.montoTotal, 'money') }}
        </span>
        <span class="ammount" *ngIf="paymentOption !== 'EFECTIVO' && payment.opcion.cuotas > 1">
            Monto a pagar: {{ utilsService.parseByType(payment.opcion.montoTotal, 'money') }} en {{ payment.opcion.cuotas }} cuotas de {{ utilsService.parseByType(payment.opcion.montoPorCuota, 'money') }}
        </span>
        <span class="ammount" *ngIf="paymentOption === 'EFECTIVO'">
            Monto sugerido: {{ utilsService.parseByType(getQuoteOptions('EFECTIVO')[0]?.montoTotal, 'money') }}
        </span>
        <form class="transfer-form" *ngIf="paymentOption === 'TRANSFERENCIA'" [formGroup]="transferForm">
            <div class="bank-transfer-details">
                <span class="bank-transfer-detail-item">
                    CBU: <span class="bold">{{ paymentInformation.cbu }}.</span>
                </span>
                <span class="bank-transfer-detail-item">
                    Alias: <span class="bold">{{ paymentInformation.alias }}.</span>
                </span>
                <span class="bank-transfer-detail-item">
                    CUIT: <span class="bold">{{ utilsService.parseByType(paymentInformation.cuit, 'cuit') }}.</span>
                </span>
                <span class="bank-transfer-detail-item">
                    Nombre: <span class="bold">{{ paymentInformation.titular }}.</span>
                </span>
            </div>
            <div class="file-input-container">
                <span class="file-input-label">Comprobantes de pago</span>
                <input type="file" class="file-input" (change)="uploadPaymentProofs($event)" multiple>
            </div>
            <mat-form-field class="garantor-form-field ammount-input" appearance="outline">
                <mat-label>Monto pagado</mat-label>
                <input matInput type="number" formControlName="montoPagado">
                <span matPrefix class="money-prefix">$</span>
                <mat-error *ngIf="transferForm.controls.montoPagado.hasError('required')">
                    Por favor ingrese un monto
                </mat-error>
            </mat-form-field>
        </form>
        <form class="cash-form" *ngIf="paymentOption && paymentOption === 'EFECTIVO'" [formGroup]="cashForm">
            <mat-form-field class="garantor-form-field ammount-input" appearance="outline">
                <mat-label>Monto pagado</mat-label>
                <input matInput type="number" formControlName="montoPagado">
                <span matPrefix class="money-prefix">$</span>
                <mat-error *ngIf="cashForm.controls.montoPagado.hasError('required')">
                    Por favor ingrese un monto
                </mat-error>
            </mat-form-field>
        </form>
    </div>
</div>
